package org.ssoft.server.boundary.icons

import io.ktor.websocket.*
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.decodeFromByteArray
import kotlinx.serialization.encodeToByteArray
import org.ssoft.common.server.icons.IconIO

@Suppress("unused")
object BoundaryIcons {

    @ExperimentalSerializationApi
    suspend fun WebSocketSession.sendRequest(message:IconIO.Query){
        send(PROTO_INSTANCE_ICONS.encodeToByteArray<IconIO>(message))
    }

    @ExperimentalSerializationApi
    suspend fun WebSocketSession.sendRequest(message:IconIO.Random){
        send(PROTO_INSTANCE_ICONS.encodeToByteArray<IconIO>(message))
    }

    @ExperimentalSerializationApi
    fun decodeResult(input:ByteArray):IconIO.Result{
       return PROTO_INSTANCE_ICONS.decodeFromByteArray<IconIO.Result>(input)
    }
}